import React from 'react';
import styled, { css } from 'styled-components';
import { getNeutralColors } from '../theme';
import { BodyText2Css } from '../typography';
import { Icon } from '../Icon/Icon';

const isActive = css`
  ${props =>
    props.active === true &&
    css`
      background: ${getNeutralColors('grisMedio')};
    `}
`;

const isSelected = css`
  ${props =>
    props.selected === true &&
    css`
      background: ${getNeutralColors('grisClaro')};
      font-weight: 600;
    `}
`;

const StyledItemList = styled.li`
  ${BodyText2Css}
  margin: 0;
  padding: 9px 12px;
  height: 40px;
  display: flex;
  align-items: center;
  background: ${getNeutralColors('white')};
  ${isSelected}
  ${isActive}
    :hover {
    background: ${getNeutralColors('grisClaro')};
    ${isActive}
    ${isSelected}
    cursor: pointer;
  }
`;

const StyledIcon = styled.span`
  pointer-events: none;
`;

const DropdownItem = ({ children, active = false, selected = false, checkbox = false, onClick = () => {} }) => {
  const onActiveClick = e => {
    onClick(e);
  };

  const childrens = React.Children.map(children, child => {
    if (!React.isValidElement(child)) {
      return child;
    }

    return React.cloneElement(child, {
      ...child.props
    });
  });

  return (
    <StyledItemList active={active} selected={selected} onClick={e => onActiveClick(e)}>
      {checkbox && (
        <StyledIcon>
          <Icon name={selected ? 'checkbox' : 'unCheckbox'} size={100} margin='0px 8px 0px 0px' />
        </StyledIcon>
      )}
      {childrens}
    </StyledItemList>
  );
};

export default DropdownItem;
